import { render } from "./WorkBillStatistics.vue?vue&type=template&id=13c38509"
import script from "./WorkBillStatistics.vue?vue&type=script&lang=js"
export * from "./WorkBillStatistics.vue?vue&type=script&lang=js"

import "./WorkBillStatistics.vue?vue&type=style&index=0&id=13c38509&lang=scss"

import exportComponent from "/Users/user/Desktop/prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__